// extracted by mini-css-extract-plugin
export var termsOfServicePage = "termsOfService-module--termsOfServicePage--bq++w";
export var wrapper = "termsOfService-module--wrapper--w0+vW";
export var inner = "termsOfService-module--inner--9f3QJ";